module.exports = __webpack_public_path__ + "img/pointer.5ed14660.png";